export default __webpack_public_path__ + "static/media/learningPath.511939ff.svg";